import {
    getTextOperator,
    getTextQuery,
    getTextString,
    Operator,
    RangeOperatorMapping
} from '@priority-software/priority-utils/lib/operators';
import {priority} from '@priority-software/priority-proto-api/lib';

import {StrOperatorMapping, TextApiOperatorMapping} from '../../types/operator';
import {IExtendedCondition, ISearchCondition, ISearchFilter} from '../../types/filters';

function buildQuery(filter: ISearchCondition): IExtendedCondition[] {
    const {values, operator, columnID, ignoreCase, columnName} = filter;

    if (operator === Operator.Empty || operator === Operator.NotEmpty) {
        return [
            {
                Values: [''],
                Operator:
                    TextApiOperatorMapping[operator] ||
                    priority.netitems.shared.ComparisonOperator.Eq,
                ColumnID: columnID,
                IgnoreCase: ignoreCase,
                ColumnName: columnName
            }
        ];
    }
    const Values = values.map(value => getTextQuery(operator, value));
    return Values.map(value => ({
        Values: [value],
        Operator:
            TextApiOperatorMapping[operator] || priority.netitems.shared.ComparisonOperator.Eq,
        ColumnID: columnID,
        IgnoreCase: ignoreCase,
        ColumnName: columnName
    }));
}

function serialize(conditions: priority.netitems.form.ICondition[]): ISearchFilter {
    const Values = conditions.map(condition => condition.Values[0]);
    const filter = conditions[0];
    const {ColumnID, IgnoreCase, Operator: origOperator} = filter;

    let operator = Operator.Contains;

    if (
        origOperator === priority.netitems.shared.ComparisonOperator.IsNull ||
        origOperator === priority.netitems.shared.ComparisonOperator.IsNotNull
    ) {
        return {
            values: [],
            operator:
                origOperator === priority.netitems.shared.ComparisonOperator.IsNull
                    ? Operator.Empty
                    : Operator.NotEmpty,
            columnID: ColumnID,
            ignoreCase: IgnoreCase
        };
    }

    const values = Values.map(value => {
        if (origOperator === priority.netitems.shared.ComparisonOperator.Eq) {
            operator = getTextOperator(value);
        } else {
            operator = RangeOperatorMapping[StrOperatorMapping[origOperator]];
        }

        return getTextString(value);
    });
    return {
        values: values,
        operator,
        columnID: ColumnID,
        ignoreCase: IgnoreCase
    };
}

export {buildQuery, serialize};
